import { BASE_HOME_URL } from '@/constants/API'

export const LOAD_HOME = 'LOAD_HOME'
export const LOAD_HOME_ASYNC = 'LOAD_HOME_ASYNC'

const home = {
  state: {
    docs: [],
    doc: null
  },
  getters: {
    homeCount: state => state.docs.length,
    homeZMZGData: state => state.docs.zmzg,
    homeWLFYData: state => state.docs.wlfy,
    homeFGFXData: state => state.docs.fgfx,
    homeHSFData: state => state.docs.hsf,
    homeJGWData: state => state.docs.jgw,
    homeWLXData: state => state.docs.wlx,
    homeMYMZData: state => state.docs.mymz,
    homeMYData: state => state.docs.my,
    homeMZCData: state => state.docs.mzc,
    homeVideos: state => state.docs.video
  },
  actions: {
    /* 获取所有文章 */
    [LOAD_HOME_ASYNC]({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: `${BASE_HOME_URL}`,
          doHideAlert: true,
          success(result) {
            // 保存文章
            console.log(result.docs)
            commit(LOAD_HOME, result.docs)
            // 向前端通知操作成功
            resolve(result.docs)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    }
  },
  mutations: {
    /* 保存所有文章信息 */
    [LOAD_HOME](state, payload) {
      state.docs = payload
    }
  }
}
export default home



// WEBPACK FOOTER //
// ./src/components/Home/module.js